import React, { useEffect, useState } from "react";
import { sixYardAxios } from "../../../sixYardAxios";
import { useParams, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import classes from './details.module.css';
import Title from "../../containers/title/title";
import TeamForm from "./teamForm/teamForm";
import PlayerForm from "./playerForm/playerForm";
import First from "../../../assets/images/1st.png";
import Second from "../../../assets/images/2nd.png";
import Third from "../../../assets/images/3rd.png";
import Gallery from "../../containers/gallery/gallery";
import NotFound from "../../../pages/notFound/notFound";
import LoginModal from '../../containers/loginModal/loginModal';

const Details = (props) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [gallery, setGallery] = useState([]);
    const [showLoginForm, setShowLoginForm] = useState(false);
    const [notFoundPage, setNotFoundPage] = useState(null);
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 600);
    useEffect(() => {
        fetchTournamentDetails();
        fetchGallery();
        
        const handleResize = () => {
            setIsDesktop(window.innerWidth >= 600);
        };
        
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        props.isAuthenticated && setShowLoginForm(false);
    }, [props.isAuthenticated]);
    const fetchTournamentDetails = async () => {
        try {
            const res = await sixYardAxios.get("/tournaments/" + id);
            setData(res.data.data)
        } catch (error) {
            setNotFoundPage(true);
        }
    };
    const fetchGallery = async () => {
        try {
            const res = await sixYardAxios.get("/tournaments/" + id + "/gallery");
            setGallery(res.data.data)
        } catch (error) {
        }
    };

    // Function to format date from YYYY-MM-DD to DD-MM-YYYY
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const parts = dateString.split('-');
        if (parts.length !== 3) return dateString;
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
    };

    // Function to display age groups properly
    const formatAgeGroups = (ageRanges) => {
        if (!ageRanges || ageRanges.length === 0) return '';
        
        const ageLabels = ageRanges.map(age => {
            // Convert labels like "under12" to "Under 12"
            if (age.toLowerCase().startsWith('under')) {
                const num = age.replace(/\D/g, '');
                return `Under ${num}`;
            }
            return age;
        });
        
        return ageLabels.join(', ');
    };

    // Check if tournament is completed
    const isCompleted = data.registration?.status === "completed";

    return (
        !notFoundPage ? <div className={classes.Container}>
            <div className={classes.Path}>
                <span onClick={() => navigate('/tournaments')}>
                    {parseInt(localStorage.getItem('language')) === 1 ? "Tournament" : "البطولة"}
                </span> / 
                {parseInt(localStorage.getItem('language')) === 1 ? "Tournament Details" : "تفاصيل البطولة"}
            </div>
            <div className={classes.HeroImage} style={{ 
                backgroundImage: `url(${data.basic_info?.image})`,
                backgroundSize: isDesktop ? '100% auto' : 'cover',
                imageRendering: 'high-quality'
            }}>
                <h1>{data?.basic_info?.name}</h1>
            </div>
            {((data.registration?.type === "team" || data.registration?.type === "player") && !isCompleted) && 
                <div className={classes.EditionAndLocation}>
                    <p dir={parseInt(localStorage.getItem('language')) === 1 ? "ltr" : "rtl"} className={classes.EditionText}>
                        {parseInt(localStorage.getItem('language')) === 1 
                            ? "ready for 6 yard tournament in its fifth edition?"
                            : "هل أنت مستعد لبطولة 6 يارد في نسختها الخامسة؟"}
                    </p>
                    <p dir={parseInt(localStorage.getItem('language')) === 1 ? "ltr" : "rtl"} className={classes.LocationText}>
                        {parseInt(localStorage.getItem('language')) === 1 
                            ? "Tournament will be held at 6 yard fields in Al Madinah Al Monawara St."
                            : "ستقام البطولة في ملاعب 6 يارد في شارع المدينة المنورة"}
                    </p>
                </div>
            }
            {data.rewards && !isCompleted && 
                <div className={classes.Rewards}>
                    <Title title={parseInt(localStorage.getItem('language')) === 1 ? 'REWARDS' : 'الجوائز'} />
                    <div className={classes.RewardsList}>
                        <div>
                            <img src={Second} alt="2nd" />
                            <p>{data.prizes[1]?.amount} {data.rewards[1]?.currency || 'JD'}</p>
                        </div>
                        <div>
                            <img src={First} alt="1st" />
                            <p>{data.prizes[0]?.amount} {data.rewards[0]?.currency || 'JD'}</p>
                        </div>
                        <div>
                            <img src={Third} alt="3rd" />
                            <p>{data.prizes[2]?.amount} {data.rewards[2]?.currency || 'JD'}</p>
                        </div>
                    </div>
                </div>
            }
            {data.rules?.length > 0 && 
                <div className={classes.Rules}>
                    <Title title={parseInt(localStorage.getItem('language')) === 1 ? 'RULES' : 'القوانين'} />
                    <p>{data.rules}</p>
                </div>
            }
            {data.basic_info && 
                <div className={classes.Details}>
                    <Title title={parseInt(localStorage.getItem('language')) === 1 ? 'DETAILS' : 'التفاصيل'} />
                    {data.basic_info?.dates?.start !== data.basic_info?.dates?.end ? 
                        <div>
                            {parseInt(localStorage.getItem('language')) === 1 
                                ? `From ${formatDate(data.basic_info?.dates?.start)} to ${formatDate(data.basic_info?.dates?.end)}`
                                : `من ${formatDate(data.basic_info?.dates?.start)} إلى ${formatDate(data.basic_info?.dates?.end)}`}
                        </div> : 
                        <div>
                            {parseInt(localStorage.getItem('language')) === 1 
                                ? `From ${formatDate(data.basic_info?.dates?.start)}`
                                : `من ${formatDate(data.basic_info?.dates?.start)}`}
                        </div>
                    }
                    
                    {/* Display age groups if available */}
                    {data.basic_info?.requirements?.age_range && data.basic_info?.requirements?.age_range.length > 0 && (
                        <div>
                            {parseInt(localStorage.getItem('language')) === 1 
                                ? `Age Group: ${formatAgeGroups(data.basic_info?.requirements?.age_range)}`
                                : `الفئة العمرية: ${formatAgeGroups(data.basic_info?.requirements?.age_range)}`}
                        </div>
                    )}
                    
                    {data.registration?.registered_teams > 0 && 
                        <div>
                            {parseInt(localStorage.getItem('language')) === 1 
                                ? `${data.registration?.registered_teams} teams ${isCompleted ? 'competed' : 'will compete'} on the title`
                                : `${data.registration?.registered_teams} فريق ${isCompleted ? 'تنافسوا' : 'سيتنافسون'} على اللقب`}
                        </div>
                    }
                    {data.basic_info?.requirements?.team_size > 0 &&
                        <div>
                            {parseInt(localStorage.getItem('language')) === 1 
                                ? `Each team has ${data.basic_info?.requirements?.goalkeeper_required ? data.basic_info?.requirements?.team_size - 1 : data.basic_info?.requirements?.team_size} Players ${data.basic_info?.requirements?.goalkeeper_required ? "and goalkeeper" : ""}`
                                : `كل فريق يتكون من ${data.basic_info?.requirements?.goalkeeper_required ? data.basic_info?.requirements?.team_size - 1 : data.basic_info?.requirements?.team_size} لاعب ${data.basic_info?.requirements?.goalkeeper_required ? "وحارس مرمى" : ""}`}
                        </div>
                    }
                    
                    {/* Only show registration information if tournament is not completed */}
                    {!isCompleted && (
                        <>
                            {data.registration?.type && 
                                <div>
                                    {parseInt(localStorage.getItem('language')) === 1 
                                        ? `Apply as ${data.registration?.type} only`
                                        : `التسجيل ${data.registration?.type === 'team' ? 'كفريق' : 'كلاعب'} فقط`}
                                </div>
                            }
                            {data.basic_info?.dates?.registration_deadline && 
                                <div>
                                    {parseInt(localStorage.getItem('language')) === 1 
                                        ? "Registration will close in "
                                        : "سيغلق التسجيل في "}
                                    <span>{formatDate(data.basic_info?.dates?.registration_deadline)}</span>
                                </div>
                            }
                            {data.registration?.fee && 
                                <div>
                                    {parseInt(localStorage.getItem('language')) === 1 
                                        ? "Registration Fees: "
                                        : "رسوم التسجيل: "}
                                    <span>{data.registration?.fee}</span> / 
                                    {parseInt(localStorage.getItem('language')) === 1 ? "Team" : "فريق"}
                                </div>
                            }
                        </>
                    )}
                </div>
            }
            {(data.registration?.type === "team" && !isCompleted) && 
                <div>
                    <Title title={parseInt(localStorage.getItem('language')) === 1 ? 'REGISTER AS TEAM' : 'التسجيل كفريق'} />
                    <TeamForm id={id} isAuthenticated={props.isAuthenticated} setShowLoginForm={setShowLoginForm}/>
                </div>
            }
            {(data.registration?.type === "player" && !isCompleted) && 
                <div>
                    <Title title={parseInt(localStorage.getItem('language')) === 1 ? 'REGISTER AS PLAYER' : 'التسجيل كلاعب'} />
                    <PlayerForm id={id} isAuthenticated={props.isAuthenticated} setShowLoginForm={setShowLoginForm}/>
                </div>
            }
            {data.standings && isCompleted && 
                <div className={classes.Rewards}>
                    <Title title={parseInt(localStorage.getItem('language')) === 1 ? 'WINNERS' : 'الفائزين'} />
                    <div className={classes.RewardsList}>
                        <div>
                            <img src={Second} alt="2nd" />
                            <p>{data.standings?.second_place?.team_name}</p>
                        </div>
                        <div>
                            <img src={First} alt="1st" />
                            <p>{data.standings?.winner?.team_name}</p>
                        </div>
                        <div>
                            <img src={Third} alt="3rd" />
                            <p>{data.standings?.third_place?.team_name}</p>
                        </div>
                    </div>
                </div>
            }
            {gallery?.length > 0 && 
                <div>
                    <Title title={parseInt(localStorage.getItem('language')) === 1 ? 'GALLERY' : 'معرض الصور'} />
                    <Gallery images={gallery} />
                </div>
            }
            {showLoginForm && <LoginModal setShowLoginForm={setShowLoginForm} currentPath={window.location.pathname} />}
        </div> : <NotFound />
    )
}
const mapStateToProps = state => ({
    isAuthenticated: state.auth.token !== null,
});
export default connect(mapStateToProps)(Details);